import * as React from 'react'
import { styled } from 'next-yak'

import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'
import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'

const TEXT_PATH = (
  <g>
    <mask id="mask0_10038_1150" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="17">
      <path d="M16 0.5H0V16.5H16V0.5Z" fill="white" />
    </mask>
    <g mask="url(#mask0_10038_1150)">
      <path d="M11.9535 12.3589H4.04762C3.67115 12.3589 3.29468 12.0766 3.29468 11.606C3.29468 11.2295 3.57703 10.853 4.04762 10.853H11.8594C12.2359 10.853 12.6123 11.1354 12.6123 11.606C12.6123 12.0766 12.33 12.3589 11.9535 12.3589Z" />
      <path d="M11.9535 9.25259H4.04762C3.67115 9.25259 3.29468 8.97023 3.29468 8.49965C3.29468 8.02906 3.57703 7.7467 4.04762 7.7467H11.8594C12.2359 7.7467 12.6123 8.02906 12.6123 8.49965C12.6123 8.87612 12.33 9.25259 11.9535 9.25259Z" />
      <path d="M11.953 6.05276H7.24708C6.87061 6.05276 6.49414 5.7704 6.49414 5.29982C6.49414 4.92335 6.77649 4.54688 7.24708 4.54688H11.953C12.3294 4.54688 12.7059 4.82923 12.7059 5.29982C12.6118 5.7704 12.3294 6.05276 11.953 6.05276Z" />
    </g>
    <path d="M14.3059 16.5H1.69412C0.752941 16.5 0 15.7471 0 14.8059V2.19412C0 1.25294 0.752941 0.5 1.69412 0.5H14.3059C15.2471 0.5 16 1.25294 16 2.19412V14.8059C16 15.7471 15.2471 16.5 14.3059 16.5ZM2.54118 15.0882H13.4588C14.1176 15.0882 14.5882 14.6176 14.5882 13.9588V3.04118C14.5882 2.38235 14.1176 1.91176 13.4588 1.91176H2.54118C1.88235 1.91176 1.41176 2.38235 1.41176 3.04118V13.8647C1.41176 14.6176 1.88235 15.0882 2.54118 15.0882Z" />
  </g>
)

const ID = 'text-stroke-glyph-icon'

export function TextSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 16 17">
      {TEXT_PATH}
    </symbol>
  )
}

const TextStandaloneContent = standalone(TextSymbol, ID)

export const Text = styled(function TextComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="text">
      <TextStandaloneContent />
    </Icon>
  )
})``

export const TextLightweight = styled(function TextComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="text-light-weight">
      {lightweight(ID)}
    </Icon>
  )
})``
